export default "__VITE_ASSET__CxwpRv$$__"